export const allModalities = ['SINGLE_CELL', 'SPATIAL'] // All modalities available on the portal
